import { Provider } from '@angular/core';
import { PriceHidableRepository } from './price-hidable.repository';

export function providePriceHidable(): Provider {
  return [PriceHidableRepository];
}
